import { render, staticRenderFns } from "./fixTab.vue?vue&type=template&id=37d70c5c&scoped=true"
import script from "./fixTab.vue?vue&type=script&lang=js"
export * from "./fixTab.vue?vue&type=script&lang=js"
import style0 from "./fixTab.vue?vue&type=style&index=0&id=37d70c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d70c5c",
  null
  
)

export default component.exports